import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ControlValueAccessor, ReactiveFormsModule } from '@angular/forms';
import { MatCheckbox, MatCheckboxChange, MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CheckboxInputModel } from '@libs/form/models';
import { ErrorDirective } from '../../../directives';
import { InputBaseComponent } from '../../../models';
import { InputProviderFactory } from '../ng-input-provider';

@Component({
  selector: 'ui-form-checkbox',
  templateUrl: './checkbox.component.html',
  providers: [
    ...InputProviderFactory.getProviders(CheckboxComponent),
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    NgClass,
    MatCheckboxModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    ErrorDirective,
  ],
})
export class CheckboxComponent extends InputBaseComponent {
  @Input()
  public data!: CheckboxInputModel;

  @ViewChild(MatCheckbox, { static: true })
  public valueAccessor!: ControlValueAccessor;

  // Material uses custom event name 'change', which we have to re-emit
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() public change: EventEmitter<MatCheckboxChange> = new EventEmitter<MatCheckboxChange>;
}
